import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { houseTypes, ownerTypes } from '../../../../constants';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function HomeSummaryCard({ customer, insuranceRequest, modifyData }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const contraente = customer.gender !== 'G'
    ? `${customer.name} ${customer.surname}`
    : customer.business_name;

  const tipoAbitazione = houseTypes.find(
    (type) => type.id === insuranceRequest.house.house_type,
  ).name;

  const tipologiaProprietario = ownerTypes.find(
    (type) => type.id === insuranceRequest.house.owner_typology,
  ).name;

  const provincia = `${insuranceRequest.house.comune.name} (${insuranceRequest.house.comune.car_plate_symbol})`;

  return (
    <Card>
      <Header>
        <Title>Casa</Title>
        {modifyData && (
          <ModificaButton type="button" onClick={() => modifyData()}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>{tipoAbitazione}</CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>{contraente}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Tipo Abitazione</dt>
              <dd>{tipoAbitazione}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Tipologia Propietario</dt>
              <dd>{tipologiaProprietario}</dd>
            </InfoRow>
            <InfoRow>
              <dt>La Superficie</dt>
              <dd>
                {insuranceRequest.house.square_meters}
                {' '}
                m²
              </dd>
            </InfoRow>
            <InfoRow>
              <dt>Provincia Abitazione</dt>
              <dd>{provincia}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default HomeSummaryCard;
